export enum equinoxAbbreviations {
  EQ_A = 'EQ:A',
  EQ_B = 'EQ:B',
}
